import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const swissCities = [
  { name: 'Zürich', popular: true, link: '/umzug-zuerich-deutschland' },
  { name: 'Genf', popular: true, link: null },
  { name: 'Basel', popular: true, link: '/umzug-basel-deutschland' },
  { name: 'Bern', popular: true, link: '/umzug-bern-deutschland' },
  { name: 'Lausanne', popular: true, link: null },
  { name: 'Winterthur', popular: false, link: '/umzug-winterthur-deutschland' },
  { name: 'Luzern', popular: true, link: '/umzug-luzern-deutschland' },
  { name: 'St. Gallen', popular: false, link: '/umzug-stgallen-deutschland' },
  { name: 'Aargau', popular: false, link: '/umzug-aargau-deutschland' },
  { name: 'Zug', popular: false, link: '/umzug-zug-deutschland' },
  { name: 'Lugano', popular: false, link: null },
  { name: 'Biel/Bienne', popular: false, link: null },
  { name: 'Thun', popular: false, link: null },
  { name: 'Köniz', popular: false, link: null },
  { name: 'La Chaux-de-Fonds', popular: false, link: null },
  { name: 'Schaffhausen', popular: false, link: null },
  { name: 'Fribourg', popular: false, link: null },
  { name: 'Chur', popular: false, link: null },
];

const germanCities = [
  { name: 'Berlin', popular: true },
  { name: 'München', popular: true },
  { name: 'Hamburg', popular: true },
  { name: 'Frankfurt am Main', popular: true },
  { name: 'Köln', popular: true },
  { name: 'Stuttgart', popular: true },
  { name: 'Düsseldorf', popular: true },
  { name: 'Dortmund', popular: false },
  { name: 'Essen', popular: false },
  { name: 'Leipzig', popular: false },
  { name: 'Bremen', popular: false },
  { name: 'Dresden', popular: false },
  { name: 'Hannover', popular: false },
  { name: 'Nürnberg', popular: false },
  { name: 'Duisburg', popular: false },
  { name: 'Bochum', popular: false },
  { name: 'Mannheim', popular: false },
  { name: 'Karlsruhe', popular: false },
  { name: 'Augsburg', popular: false },
  { name: 'Wiesbaden', popular: false },
  { name: 'Freiburg im Breisgau', popular: false },
  { name: 'Konstanz', popular: false },
];

export default function ServiceAreas() {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-slate-800 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Unsere Servicegebiete
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Von überall in der Schweiz nach ganz Deutschland
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Wir decken alle wichtigen Städte und Regionen ab. Egal wo Sie in der Schweiz starten oder in Deutschland ankommen – wir bringen Sie und Ihr Hab und Gut sicher ans Ziel.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl p-8 border-2 border-slate-100">
            <div className="flex items-center mb-6">
              <div className="bg-red-100 p-3 rounded-xl mr-4">
                <MapPin className="w-8 h-8 text-red-600" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-slate-900">Schweiz (Abholung)</h3>
                <p className="text-slate-600">Alle Kantone & Städte</p>
              </div>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold text-slate-900 mb-3">Besonders häufig:</h4>
              <div className="flex flex-wrap gap-2 mb-4">
                {swissCities.filter(city => city.popular).map((city, index) => (
                  city.link ? (
                    <Link
                      key={index}
                      to={city.link}
                      className="bg-red-50 text-red-700 px-4 py-2 rounded-lg text-sm font-medium border border-red-200 hover:bg-red-100 hover:border-red-300 transition"
                    >
                      {city.name}
                    </Link>
                  ) : (
                    <span
                      key={index}
                      className="bg-red-50 text-red-700 px-4 py-2 rounded-lg text-sm font-medium border border-red-200"
                    >
                      {city.name}
                    </span>
                  )
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-slate-900 mb-3">Weitere Städte:</h4>
              <div className="flex flex-wrap gap-2">
                {swissCities.filter(city => !city.popular).map((city, index) => (
                  city.link ? (
                    <Link
                      key={index}
                      to={city.link}
                      className="bg-slate-100 text-slate-700 px-3 py-1 rounded-lg text-sm hover:bg-slate-200 transition"
                    >
                      {city.name}
                    </Link>
                  ) : (
                    <span
                      key={index}
                      className="bg-slate-100 text-slate-700 px-3 py-1 rounded-lg text-sm"
                    >
                      {city.name}
                    </span>
                  )
                ))}
              </div>
            </div>

            <p className="mt-6 text-sm text-slate-600">
              + alle weiteren Ortschaften in der gesamten Schweiz
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 border-2 border-slate-100">
            <div className="flex items-center mb-6">
              <div className="bg-yellow-100 p-3 rounded-xl mr-4">
                <MapPin className="w-8 h-8 text-yellow-700" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-slate-900">Deutschland (Zustellung)</h3>
                <p className="text-slate-600">Alle Bundesländer & Städte</p>
              </div>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold text-slate-900 mb-3">Besonders häufig:</h4>
              <div className="flex flex-wrap gap-2 mb-4">
                {germanCities.filter(city => city.popular).map((city, index) => (
                  <span
                    key={index}
                    className="bg-yellow-50 text-yellow-800 px-4 py-2 rounded-lg text-sm font-medium border border-yellow-200"
                  >
                    {city.name}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-slate-900 mb-3">Weitere Städte:</h4>
              <div className="flex flex-wrap gap-2">
                {germanCities.filter(city => !city.popular).map((city, index) => (
                  <span
                    key={index}
                    className="bg-slate-100 text-slate-700 px-3 py-1 rounded-lg text-sm"
                  >
                    {city.name}
                  </span>
                ))}
              </div>
            </div>

            <p className="mt-6 text-sm text-slate-600">
              + alle weiteren Städte und Gemeinden in ganz Deutschland
            </p>
          </div>
        </div>

        <div className="mt-12 bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 md:p-12 text-center text-white max-w-4xl mx-auto">
          <h3 className="text-3xl font-bold mb-4">
            Ihre Stadt nicht dabei?
          </h3>
          <p className="text-slate-200 text-lg mb-6">
            Kein Problem! Wir bedienen alle Orte in der Schweiz und Deutschland. Kontaktieren Sie uns für eine individuelle Offerte.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a
              href="tel:0800700100"
              className="bg-white hover:bg-slate-100 text-slate-900 px-8 py-4 rounded-lg font-semibold transition shadow-lg hover:shadow-xl flex items-center"
            >
              0800 700 100 (Gratis)
              <ArrowRight className="ml-2 w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
